<script setup>
/*
    Video widget - play sound

    Components:
        primary: <v-btn>

    Widget Properties:
        header
        url: string | map | list
            Maps: { value: url }
            List: { expression, url, end, start, autoplay, loop, fullscreen }
            # https://www.youtube.com/embed/eIG5z-DcrIo

    Component Args
        --w-autoplay
        --w-end
        --w-fullscreen: true
        --w-loop
        --w-start

    CSS Properties:

 */

import {reactive, ref} from 'vue'
import {getWidgetProps, pickItem} from '@/paks/vu-dash/BoardUtils'
import {State} from '@/paks/vu-app'

defineExpose({update})

const props = defineProps({widget: Object})

const page = reactive({
    args: {},
    data: {},
    item: {},
    src: null,
})

const primary = ref(null)

function update() {
    let widget = props.widget
    Object.assign(page, getWidgetProps(widget, {primary}, {variant: 'flat'}))

    page.item = pickItem(widget.url, {
        context: {inputs: State.context.inputs, value: page.data.primary},
    })
}
</script>

<template>
    <iframe ref="primary" class="video-widget"
        title="video" 
        frameborder="0" 
        allow="autoplay; encrypted-media"
        :autoplay="page.args.autoplay ? 1 : 0"
        :muted="page.args.autoplay ? 1 : 0"
        :allowfullscreen="page.args.fullscreen ? 1 : 0"
        :start="page.args.start"
        :end="page.args.end"
        :title="props.widget.header"
        :loop="page.args.loop ? 1 : 0"
        :src="page.item.value"
    />
</template>

<style lang="scss" scoped>
.video-widget {
    container-type: size;
    position: relative;
    height: 100cqh !important;
    width: 100cqw !important;
    transform: translateY(-50%);
    top: 50%;
}
</style>
